// Notificación FLOTANTE de bandejas PERSONALES configurables: si el usuario logueado es el DUEÑO
// de alguna bandeja de WhatsApp (conversacion_categorias.agente_id) y tiene conversaciones NUEVAS
// derivadas a ella, aparece un banner flotante en TODA la app (también móvil, donde el chip del
// filtro no se ve) que parpadea y, al pulsarlo, lleva directo a esa bandeja en /whatsapp.
// Antes esto iba hardcodeado por email (Cristian/Guillem); ahora es data-driven por agente_id (#10).
import { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import api from '../services/api'
import { useAuth } from '../context/AuthContext'
import { Ico } from './ui'
// t515 · B-2248 · «Te derivan una conversación a tu bandeja» (Notificaciones → Configurar y el Perfil).
import { meLlegaDe, CLAVE_MIS_AVISOS, RUTA_MIS_AVISOS } from '../utils/misAvisos'
import { t, tx } from '../utils/i18n'   // B-2259 · los textos, en el idioma de quien mira (utils/i18n)

export default function NotifPersonal() {
  const { user } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const [descartadoEn, setDescartadoEn] = useState(0)   // nº de nuevas cuando se descartó

  // Bandejas de las que el usuario logueado es DUEÑO (por agente_id, no por email).
  // t85 · a quien no le tocan las conversaciones (403) se le deja de preguntar cada minuto toda la sesión.
  const [sinPermiso, setSinPermiso] = useState(false)
  const { data: categorias = [] } = useQuery({
    queryKey: ['conv-categorias'],
    queryFn: () => api.get('/conversaciones/categorias').then(r => r.data).catch((e) => { if (e?.response?.status === 403) setSinPermiso(true); return [] }),
    refetchInterval: sinPermiso ? false : 60000,
    enabled: !!user?.id && !sinPermiso,
  })
  const mias = categorias.filter(c => c.agente_id === user?.id)

  const { data: contadores } = useQuery({
    queryKey: ['notif-personal'],
    queryFn: () => api.get('/conversaciones/contadores', { timeout: 15000 }).then(r => r.data).catch(() => null),
    enabled: mias.length > 0,
    refetchInterval: 15000,
  })
  // t515 · si la clínica lo tiene apagado (o la persona se lo ha quitado), no se pinta. Sin respuesta, como siempre.
  const { data: misAvisos } = useQuery({
    queryKey: CLAVE_MIS_AVISOS,
    queryFn: () => api.get(RUTA_MIS_AVISOS).then(r => r.data).catch(() => null),
    enabled: mias.length > 0, staleTime: 5 * 60 * 1000,
  })
  if (!mias.length || !contadores || !meLlegaDe(misAvisos, 'conversaciones.bandeja_personal', 'ventana')) return null

  // De mis bandejas, la que tiene MÁS conversaciones nuevas sin ver.
  let cat = null, nuevas = 0
  for (const c of mias) {
    const n = Number(contadores[c.slug + '_nuevas'] || 0)
    if (n > nuevas) { nuevas = n; cat = c }
  }

  // Reaparece si llegan MÁS nuevas que cuando se descartó; se oculta dentro de /comunicacion.
  if (!cat || nuevas <= 0 || nuevas <= descartadoEn || location.pathname === '/comunicacion' || location.pathname === '/whatsapp' || location.pathname === '/conversaciones') {
    if (nuevas === 0 && descartadoEn !== 0) setDescartadoEn(0)
    return null
  }

  return (
    <>
      <div onClick={() => navigate('/comunicacion?cat=' + cat.slug)}
        // t302 · la capa de los avisos que flotan (index.css, «LAS CAPAS DE LA APLICACIÓN»): con 3000 era la de las ventanas
        // y quedaba encima de un desplegable de la barra recién abierto.
        style={{ position: 'fixed', top: '14px', left: '50%', transform: 'translateX(-50%)', zIndex: 'var(--capa-aviso-flotante)',
          display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 16px', maxWidth: 'calc((100vw / var(--z, 1)) - 24px)',
          background: 'var(--danger)', color: '#fff', borderRadius: 'var(--radius-lg)',
          boxShadow: '0 8px 30px color-mix(in srgb, var(--danger) 45%, transparent)',
          cursor: 'pointer', animation: 'notifpersonal 1.4s infinite' }}>
        <span style={{ width: '38px', height: '38px', borderRadius: '11px', flexShrink: 0, fontSize: '22px', lineHeight: 1,
          display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(255,255,255,0.2)' }}>{cat.icono || <Ico n="conversaciones" s={20} />}</span>
        <span style={{ minWidth: 0, display: 'flex', flexDirection: 'column', gap: '1px', fontSize: '14px', fontWeight: 800, lineHeight: 1.3 }}>
          {tx('components.NotifPersonal.para_ti', '{{x}} para ti', { x: nuevas === 1 ? t('components.NotifPersonal.tienes_1_conversacion_nueva', 'Tienes 1 conversación nueva') : t('components.NotifPersonal.tienes_conversaciones_nuevas', 'Tienes {{nuevas}} conversaciones nuevas', { nuevas }) })}
          <span style={{ fontSize: '11.5px', fontWeight: 600, opacity: 0.9 }}>{t('components.NotifPersonal.toca_para_abrirlas', 'Toca para abrirlas')}</span>
        </span>
        <button onClick={e => { e.stopPropagation(); setDescartadoEn(nuevas) }}
          title={t('components.NotifPersonal.descartar', 'Descartar')}
          style={{ background: 'rgba(255,255,255,0.22)', border: 'none', color: '#fff', borderRadius: '50%', width: '26px', height: '26px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', flexShrink: 0 }}>
          <Ico n="x" s={15} c="#fff" />
        </button>
      </div>
      <style>{`@keyframes notifpersonal{0%,100%{box-shadow:0 8px 30px color-mix(in srgb, var(--danger) 45%, transparent)}50%{box-shadow:0 8px 40px color-mix(in srgb, var(--danger) 85%, transparent)}}`}</style>
    </>
  )
}
